import { IPivotItemProps, TooltipDelay, TooltipHost } from '@fluentui/react';
import { IPPivot, IPText } from 'baseComponents';
import { IPPivotItem } from 'baseComponents/Pivot/IPPivotItem';
import { globalPaddingScene, globalTextStylesBold } from 'globalStyles';
import ResourceLink from 'models/resourceLink';
import { useEffect, useState } from 'react';
import { overflow } from 'utils/string';

//
// Pinned link tabs
//
export interface IPinnedLinkTabsProps {
  links: ResourceLink[];
  selectedLink?: ResourceLink;
  onClick: (link: ResourceLink) => void;
}

const PinnedLinkTabs = (props: IPinnedLinkTabsProps) => {
  const [selectedKey, setSelectedKey] = useState<string | null>(null);

  const handleLinkClick = (item: IPPivotItem | undefined) => {
    if (item && item.props.itemKey) {
      const link = props.links.find((i) => getKey(i) === item.props.itemKey);
      if (link) {
        props.onClick(link);
      }
    }
  };

  useEffect(() => {
    setSelectedKey(getKey(props.selectedLink));
  }, [props.selectedLink]);

  const getKey = (link: ResourceLink | undefined): string | null => {
    if (!link) return null;

    return 'tab' + link.linkId.toString();
  };

  //remove the bold view when no pivot item is selected
  const renderItem = (
    itemProps?: IPivotItemProps,
    defaultRender?: (itemProps?: IPivotItemProps) => JSX.Element | null,
    link?: ResourceLink,
  ): JSX.Element | null => {
    return (
      //show tooltip when header is capped
      <TooltipHost
        delay={TooltipDelay.zero}
        content={itemProps?.headerText !== link?.linkName ? link?.linkName : undefined}
      >
        <IPText styles={itemProps?.itemKey === selectedKey ? globalTextStylesBold : undefined}>
          {itemProps?.headerText}
        </IPText>
      </TooltipHost>
    );
  };

  //remove the blue underline when no pivot item is selected
  const getPivotStyles = () => {
    return !selectedKey
      ? {
          root: {
            paddingLeft: globalPaddingScene,
          },
          linkIsSelected: {
            selectors: {
              '&:before': { height: 0 },
            },
          },
        }
      : {
          root: {
            paddingLeft: globalPaddingScene,
          },
        };
  };

  return (
    <IPPivot
      overflowBehavior="menu"
      headersOnly={true}
      selectedKey={selectedKey}
      onLinkClick={handleLinkClick}
      styles={getPivotStyles()}
    >
      {props.links.map((link) => {
        return (
          <IPPivotItem
            key={link.linkId}
            headerText={overflow(link.linkName, 25)}
            itemKey={getKey(link) ?? ''}
            onRenderItemLink={(itemProps, defaultRender) => renderItem(itemProps, defaultRender, link)}
          ></IPPivotItem>
        );
      })}
    </IPPivot>
  );
};

export default PinnedLinkTabs;
